import { PROFILE_LOGS_KEY } from './key'

const PROFILE_LOGS_STATE = {
  [PROFILE_LOGS_KEY.ALL]: {
    data: [],
    status: null
  },
  [PROFILE_LOGS_KEY.CURRENT]: null,
  [PROFILE_LOGS_KEY.DATA]: {}
}

export { PROFILE_LOGS_STATE }
